import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import {
  CreateLlmStrategyRootScreenParamList,
  ManageLlmStrategiesParamList,
} from "../../../../types";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import React from "react";

import { CreateLlmStrategyScreen } from "./CreateLlmStrategyScreen";
import { LlmStrategyForm } from "../../components/LlmStrategyForm";
import { SelectLlmTypeScreen } from "./SelectLlmTypeScreen";
import { SelectOpenAiModelScreen } from "./SelectOpenAiModelScreen";
import { SelectGeminiModelScreen } from "./SelectGeminiModelScreen";
import { SelectAnthropicModelScreen } from "./SelectAnthropicModelScreen";
import { SelectOpenAiDalleModelScreen } from "./SelectOpenAiDalleModelScreen";

const Stack =
  createStackHeaderNavigator<CreateLlmStrategyRootScreenParamList>();

export interface CreateLlmStrategyRootScreenProps
  extends StackScreenProps<
    ManageLlmStrategiesParamList,
    "CreateLlmStrategyRootScreen"
  > {}

export const CreateLlmStrategyRootScreen = ({
  navigation,
}: CreateLlmStrategyRootScreenProps) => {
  return (
    <LlmStrategyForm>
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          headerShown: false,
          title: "",
        }}
      >
        <Stack.Group
          screenOptions={{
            headerShown: true,
            headerLeft: () => <ModalCloseButton type="Cancel" />,
          }}
        >
          <Stack.Screen
            name="CreateLlmStrategyScreen"
            component={CreateLlmStrategyScreen}
          />
        </Stack.Group>
        <Stack.Group
          screenOptions={{
            headerShown: true,
            title: "",
          }}
        >
          <Stack.Screen
            name="SelectLlmTypeScreen"
            component={SelectLlmTypeScreen}
          />
          <Stack.Screen
            name="SelectOpenAiModelScreen"
            component={SelectOpenAiModelScreen}
          />
          <Stack.Screen
            name="SelectAnthropicModelScreen"
            component={SelectAnthropicModelScreen}
          />
          <Stack.Screen
            name="SelectGeminiModelScreen"
            component={SelectGeminiModelScreen}
          />
          <Stack.Screen
            name="SelectOpenAiDalleModelScreen"
            component={SelectOpenAiDalleModelScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </LlmStrategyForm>
  );
};
